// initial state
const state = {
    toasts: []
};

// getters
const getters = {
    toasts: state => {
        return state.toasts;
    }
};

// actions
const actions = {
    addToast({ commit }, toast) {
        commit("PUSH", toast);
    },
    removeToast({ commit }, toastToRemove) {
        commit("DELETE", toastToRemove);
    }
};

// mutations

let nextId = 1;

const mutations = {
    PUSH(state, toast) {
        state.toasts.push({
            ...toast,
            id: nextId++
        });
    },
    DELETE(state, toastToRemove) {
        state.toasts = state.toasts.filter(toast => toast.id !== toastToRemove.id);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
